import { defineStore } from 'pinia';

import { ModifyLinkState } from './modifyLink.state.js';
import { NewAccountLinkClass } from 'interface/link/newAccount.js';
import ModifyLinkService from '@/services/ModifyLinkService.js';
import { Logger } from '@/middlewares/sentry.js';

export const useModifyLinkStore = defineStore('modifyLink', {
  state: (): ModifyLinkState => ({
    linkData: new NewAccountLinkClass(),
    linkId: '',
  }),
  actions: {
    async trySetupData(linkId: string) {
      try {
        await this._setLinkData(linkId);
        this.linkId = linkId;
      } catch (err) {
        Logger.error(err);
        this.linkData = new NewAccountLinkClass();
      }
    },
    async _setLinkData(linkId: string) {
      this.linkData = await ModifyLinkService.getLinkInfo(linkId);
    },
    resetData() {
      this.linkData = new NewAccountLinkClass();
      this.linkId = '';
    },
  },
  getters: {
    getLinkData: (state) => state.linkData,
  },
});
